import { apiWithPrefix as api } from '../utils/api';

export class ReportsService {
  static async getAttendanceReport(params = {}) {
    const response = await api.get('/reports/attendance', { params });
    return response.data;
  }

  static async getLeaveReport(params = {}) {
    const response = await api.get('/reports/leaves', { params });
    return response.data;
  }

  static async getStats(params = {}) {
    const response = await api.get('/reports/stats', { params });
    return response.data;
  }

  static async generateReport(type, params = {}) {
    const response = await api.get(`/reports/generate/${type}`, {
      params,
      responseType: 'blob'
    });
    return response.data;
  }
}

export default ReportsService;
